import config from '@/config'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.COMMU}/api/next-capital/customer`,
    timeout: 30000,
    headers: {
      AUTHORIZATION:
        'Bearer OEg4MkxMVEtrWlVpYXRkRnhsWmVteXZxeis4TU5UejBURFo0ZDlXbU1Xc2FSdDhGbU5HdWpvK2hEVThvN0VQcVVmbjV3L0FMUnpUYUZxMTZGWnVFNWtPbWtEWWd2azBpb3RlbFg0dStOc0k2RFpBUUxWWWxjTkh5c2puMm45dmVQd2YzMkdxZmEwQUlKQ3FaVkxUTVJnZEIwNHQ4OS8xTy93MWNEbnlpbEZVPQ=='
    }
  })

const contractApi = {
  getLoanInfo: request => {
    const { body, config } = request
    return instance().post(`/V2/loan-info`, body, {
      ...config
    })
  },
  genBarCode: request => {
    const { body, config } = request
    return instance().post(`/v2/generate-barcode`, body, {
      ...config
    })
  }
}
export default contractApi
